import { gql } from "@apollo/client"

const STATS_QUERY = gql`
    query getStats($trendDays: Int) {
        stats(department: "") {
            shopStats {
                shopId
                name
                shortName
                lang
                countMappedProducts
                countPriceChangesLastTwoWeeks
                countProducts
                countStockGreenProducts
                countStockYellowProducts
                countStockRedProducts
                productsPriceLower
                productsPriceEqual
                productsPriceHigher
            }
            activeShops
            activeProducts
            crawlsToday
            productsPriceHigher
            productsPriceEqual
            productsPriceLower
            productsPriceLowerByShops {
                id
                name
                lang
                count
                totalCount
                percentage
            }
            crawlerCountSeries
            shopsProductAllCounts {
                name
                lang
                countProducts
            }
            shopsProductMappedCounts {
                name
                lang
                countMappedProducts
            }
            avgPriceGapByShop {
                shopId
                name
                shortName
                lang
                avgGapWhenCheaper
                avgGapWhenMoreExpensive
                countCheaper
                countMoreExpensive
            }
            stockLightHistory {
                date
                shopId
                shopName
                shortName
                lang
                green
                yellow
                red
            }
            priceTrendStatistics(days: $trendDays) {
                trendDistribution {
                    risingCount
                    fallingCount
                    unchangedCount
                    risingPercent
                    fallingPercent
                    unchangedPercent
                    totalProducts
                }
                trendByCategory {
                    categoryName
                    risingCount
                    fallingCount
                    unchangedCount
                    totalCount
                    averageTrend
                }
                trendByShop {
                    shopId
                    shopName
                    lang
                    risingCount
                    fallingCount
                    unchangedCount
                    totalCount
                }
            }
            lastUpdate
        }
        shops {
            id
            colorHex
        }
        baseData {
            mainLang
        }
    }
`

const CATEGORY_TREND_QUERY = gql`
    query getCategoryTrends($department: String, $shopIds: [Long], $trendDays: Int) {
        stats(department: $department, shopIds: $shopIds) {
            priceTrendStatistics(days: $trendDays) {
                trendByCategory {
                    categoryName
                    risingCount
                    fallingCount
                    unchangedCount
                    totalCount
                }
            }
        }
    }
`

export { STATS_QUERY, CATEGORY_TREND_QUERY }
